<template>
    <MediaDefault v-bind="props" force-bem-block="slice-media--video-left" force-test-id-prefix="media-video-left">
        <template #media>
            <PrismicEmbed
                v-if="isFilled.embed(slice.primary.video)"
                :class="['slice-media--video-left__video', {'slice-media--video-left__video--compressed': slice.primary.mediaRatio}]"
                :field="slice.primary.video"
                data-testid="media-video-left-embed"
            />
        </template>
    </MediaDefault>
</template>

<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicEmbed} from '@prismicio/vue';
    import type {MediaSlice} from '@prismicio-types';
    import MediaDefault from './MediaDefault.vue';

    type MediaVideoLeftInZone = Extract<MediaSlice, {variation: 'mediaVideoLeft'}>;

    const props = defineProps(getSliceComponentProps<MediaVideoLeftInZone>());
</script>
